import { render } from "./AllStaffOps.vue?vue&type=template&id=b72a102c&scoped=true"
import script from "./AllStaffOps.vue?vue&type=script&lang=js"
export * from "./AllStaffOps.vue?vue&type=script&lang=js"

import "./AllStaffOps.vue?vue&type=style&index=0&id=b72a102c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72a102c"]])

export default __exports__